import AppLayout from "@/layouts/AppLayout";
import { FacilityDetailsHeader } from "../../_components/FacilityDetailsHeader";
import { useLocation, useParams } from "react-router-dom";
import JobsTabs from "../_JobsTabs";
import { useFacilityNavLinks } from "../../_utils";
import PageTitle from "@/components/PageTitle";
import Breadcrumb from "@/components/Breadcrumb";

export default function FacilityJobsPage() {
  const { facilityId } = useParams();
  const location = useLocation();
  const navLinks = useFacilityNavLinks(facilityId);

  if (!facilityId) return null;

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      <div data-testid="jobs-page">
        <Breadcrumb
          compactOnly
          compactTitle="Facility Jobs"
          backLink={{
            to: "/facilities/:facilityId",
            params: { facilityId }
          }}
        />
        <PageTitle pattern={location.pathname} title={"Facilities | Facility Details"} />
        <FacilityDetailsHeader facilityId={facilityId!} />
        <div>
          <JobsTabs />
        </div>
      </div>
    </AppLayout>
  );
}
